<template>
  <div class="home dis_f fle_t">
    <img
      src="@/assets/img/audio_open.png"
      v-if="$store.state.audioPlay"
      class="contro_audio active"
      @click="$store.commit('setAudioPlay',false)"
      alt
    >
    <img
      src="@/assets/img/audio_close.png"
      @click="$store.commit('setAudioPlay',true)"
      v-else
      class="contro_audio"
      alt
    >
    <img src="@/assets/img/begin_top.png" class="w100 fle_no" alt>
    <div class="fl1"></div>
    <router-link tag="div" to="index" class="begin_more w100 dis_f jus_rt fle_no">
      <img data-name="发现更多" src="@/assets/img/begin_btn.png" alt>
    </router-link>
    <img src="@/assets/img/begin_logo.png" class="begin_txt fle_no" alt>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.home {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  background: #000000;
  padding-top: 47px;
  .begin_more {
    margin-top: 21px;
    margin-bottom: 27px;
    height: 105px;
    img {
      height: 105px;
    }
  }
  .begin_txt {
    width: 343px;
    padding-bottom: 69px;
    margin-left: 30px;
  }
}
</style>

